import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';

@Component({
    selector: 'app-dau-v5',
    templateUrl: './dau-v5.component.html',
    styleUrls: ['./dau-v5.component.css']
})
export class DauV5Component implements OnInit, OnChanges {

    @Input() paramFormDauV5: FormGroup;
    @Input() readOnly: boolean;
    @Input() mode: 'create' | 'update' | 'delete';
    @Input() deviceUid: number;
    havingValue: boolean;

    constructor() {
    }

    ngOnInit() {
        if (this.paramFormDauV5.controls.screwTerminalBlock.value) {
            this.havingValue = true;
        }
        if (this.isSTBValueEditable()) {
            this.setUidAsSTBValue();
        }
    }

    ngOnChanges() {
        if (this.isSTBValueEditable()) {
            this.setUidAsSTBValue();
        }
    }

    setUidAsSTBValue() {
        this.havingValue = false;
        this.paramFormDauV5.controls.screwTerminalBlock.setValue(this.deviceUid);
    }

    private isSTBValueEditable() {
        return !this.readOnly && !this.havingValue;
    }

}
